import { Link } from "react-router-dom";
import { ArrowUpLeft, Clock3 } from "lucide-react";
import ArticleCover from "@/components/public/ArticleCover";

export function formatArticleDate(value) {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : new Intl.DateTimeFormat("ar", { year: "numeric", month: "long", day: "numeric" }).format(date);
}

export default function ArticleCard({ article, categoryName = article.category_name }) {
  const languageParam = article.language === "en" ? "?language=en" : "";
  return (
    <article className="aran-card group flex h-full flex-col overflow-hidden p-5 transition-transform hover:-translate-y-1" data-testid={`article-card-${article.slug}`}>
      <ArticleCover src={article.cover_image_url} alt={article.cover_image_alt} className="-mx-5 -mt-5 mb-4" />
      <div className="mb-4 flex items-center justify-between gap-3 text-xs text-muted-foreground">
        {categoryName ? <span className="rounded-full bg-primary/10 px-3 py-1 font-semibold text-primary">{categoryName}</span> : <span />}
        <span className="inline-flex items-center gap-1.5"><Clock3 className="h-3.5 w-3.5" />{article.reading_time_minutes || 1} دقائق</span>
      </div>
      <h2 className="font-head text-lg font-bold leading-8 group-hover:text-primary">
        <Link to={`/learn/${encodeURIComponent(article.slug)}${languageParam}`} className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{article.title}</Link>
      </h2>
      {article.excerpt && <p className="mt-2 line-clamp-3 text-sm leading-7 text-muted-foreground">{article.excerpt}</p>}
      <div className="mt-auto flex items-center justify-between gap-3 pt-5 text-xs text-muted-foreground">
        <time dateTime={article.published_at || undefined}>{formatArticleDate(article.published_at)}</time>
        <Link to={`/learn/${encodeURIComponent(article.slug)}${languageParam}`} aria-label={`قراءة ${article.title}`} className="inline-flex items-center gap-1 font-semibold text-primary">
          اقرأ المقال <ArrowUpLeft className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </article>
  );
}
